// This file is autogenerated from /frontend/sail-next/packages/docs/src/component-examples/Notice/Actions.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { Notice, Button, view, css } from '@sail/ui';
export const Actions = () => 
<view.div css={{maxWidth: css.value('500px')}}>
  <Notice 
    type="neutral"
    title="Check your bank account information"
    description="If you believe the bank account information you provided is incorrect or out of date, simply edit your bank account information and Stripe will automatically attempt your payouts again."
    actions={<Button onPress={() => console.log('hello world')}>Update bank account</Button>} 
  />
</view.div>;


